import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api, { ApiResponse } from "../../services/api";
import { useOrder } from "./OrderContext";

const TokenConfirmation: React.FC = () => {
  const { tempOrderId } = useParams<{ tempOrderId: string }>();
  const navigate = useNavigate();
  const { setOrderData } = useOrder();
  const [tokenNumber, setTokenNumber] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!tempOrderId) return;
    api
      .get<ApiResponse<any>>(`/temp-orders/${tempOrderId}`)
      .then((res) => {
        if (res.data.success) {
          setTokenNumber(res.data.data.tokenNumber);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [tempOrderId]);

  const handleDone = () => {
    setOrderData({});
    navigate("/choice");
  };

  return (
    <div className="w-full h-screen flex flex-col items-center justify-center bg-white gap-8">
      <h1 className="text-3xl font-bold text-gray-700">Pay at Counter</h1>

      {loading ? (
        <p className="text-gray-400 text-xl">Loading...</p>
      ) : tokenNumber !== null ? (
        <>
          <p className="text-lg text-gray-500">Your token number is</p>
          <div className="flex items-center justify-center w-64 h-64 rounded-full border-8 border-main">
            <span className="text-8xl font-extrabold text-main">
              {String(tokenNumber).padStart(3, "0")}
            </span>
          </div>
          <p className="text-gray-500 text-center max-w-xs">
            Please proceed to the counter with this token to complete your
            payment.
          </p>
        </>
      ) : (
        <p className="text-red-500">Could not load token. Please try again.</p>
      )}

      <button
        onClick={handleDone}
        className="mt-4 px-10 py-4 bg-main text-white text-xl font-semibold rounded-2xl hover:opacity-90 transition"
      >
        Done
      </button>
    </div>
  );
};

export default TokenConfirmation;
